import twitchIcon from "@/assets/chatbots/icons/twitch.png";
import discordScreenshot from "@/assets/chatbots/screenshots/discord-screenshot.jpg";

import twitchScreenshot from "@/assets/chatbots/screenshots/twitch-screenshot.jpg";
import discordIcon from "@/assets/social-icons/discord-icon.png";

import type { Chatbot } from "./types";

const discordButtonURL =
  "https://discord.com/api/oauth2/authorize?client_id=" +
  import.meta.env.VITE_PUBLIC_DISCORD_ID +
  "&permissions=8&scope=bot%20applications.commands";

export const chatbots = {
  discord: {
    images: [discordScreenshot],
    category: "chatbots",
    name: "Discord Chatbot",
    link: "/chatbots/discord",
    thumbnail: discordIcon,
    shortDescription:
      "Use Discord bot commands to keep your community up-to-date on your fundraising progress.",
    features: [
      "Allows your community to stay informed about your Tiltify goals,milestones, polls, rewards and recent donations.",
      "Easily lets your community know facts about St. Jude and how your donation impacts the hospital.",
      "Posts your Tiltify donation link into your server",
      "Includes helpful links regarding employer-matching, Inspire stories, virtual tour and many more!",
      "Commands available include: /sjsetup (connects the bot to a Tiltify campaign), /sjdonate, /sjfact, sjmilesones and many more!",
    ],
    description:
      "Utilize our Discord chatbot to enhance your fundraising campaign on your server! Keep your community up-to-date on your fundraising progress and let them stay informed about St. Jude Children's Research Hospital through various bot commands.",
    show: "yes",
    connectURL: discordButtonURL,
  },
  twitch: {
    name: "Twitch Chatbot",
    images: [twitchScreenshot],
    thumbnail: twitchIcon,
    show: true,
    shortDescription:
      "Use Twitch bot commands to keep your community up-to-date on your fundraising progress.",
    link: "/chatbots/twitch",
    description:
      "Utilize our chatbot to enhance your Tiltify fundraising campaign. Keep your viewers up-to-date on your fundraising progress and inform them about St. Jude Children's Research Hospital through various chatbot commands.",
    features: [
      "Connects directly to your Tiltify campaign",
      "Keeps track of your fundraising goal, milestones, incentives, and more",
      "Automatically post your donation link in chat",
      "Announces hitting key fundraising milestones",
      "Posts facts about St. Jude Children's Research Hospital",
    ],
  },
} satisfies Record<string, Chatbot>;
